import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AlignLeft = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33301 3.83301C2.05687 3.83301 1.83301 4.05687 1.83301 4.33301C1.83301 4.60915 2.05687 4.83301 2.33301 4.83301H13.6663C13.9425 4.83301 14.1663 4.60915 14.1663 4.33301C14.1663 4.05687 13.9425 3.83301 13.6663 3.83301H2.33301ZM1.83301 7.99967C1.83301 7.72353 2.05687 7.49967 2.33301 7.49967H13.6663C13.9425 7.49967 14.1663 7.72353 14.1663 7.99967C14.1663 8.27582 13.9425 8.49967 13.6663 8.49967H2.33301C2.05687 8.49967 1.83301 8.27582 1.83301 7.99967ZM1.83301 11.6663C1.83301 11.3902 2.05687 11.1663 2.33301 11.1663H8.33301C8.60915 11.1663 8.83301 11.3902 8.83301 11.6663C8.83301 11.9425 8.60915 12.1663 8.33301 12.1663H2.33301C2.05687 12.1663 1.83301 11.9425 1.83301 11.6663Z"
        fill={color}
      />
    </svg>
  )
})

export default AlignLeft
